"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Api_1 = __importDefault(require("@/Components/Api/Api"));
var AppLayout_1 = __importDefault(require("@/Layouts/AppLayout"));
var react_i18next_1 = require("react-i18next");
var OAuth2ClientComponent_1 = __importDefault(require("@/Components/Api/OAuth2ClientComponent"));
var Tab_1 = __importDefault(require("@/Components/common/Tab"));
var Api_module_css_1 = __importDefault(require("../../Components/Api/Api.module.css"));
function ApiTokenIndex(_a) {
    var tokens = _a.tokens, availablePermissions = _a.availablePermissions, defaultPermissions = _a.defaultPermissions;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _b = (0, react_1.useState)("OAuth2"), activeTab = _b[0], setActiveTab = _b[1];
    var handleTabChange = function (tab) {
        setActiveTab(tab);
    };
    return (react_1.default.createElement(AppLayout_1.default, { title: "API", renderHeader: function () { return (react_1.default.createElement("h2", { className: "header" }, t("API"))); } },
        react_1.default.createElement("div", { className: "max-w-7xl mx-auto py-10 sm:px-6 lg:px-8" },
            react_1.default.createElement("div", { className: Api_module_css_1.default["tab-container"] },
                react_1.default.createElement(Tab_1.default, { onClick: function () { return handleTabChange("OAuth2"); }, text: t("OAuth 2"), active: activeTab === "OAuth2", dataCy: "OAuth2Tab" }),
                react_1.default.createElement(Tab_1.default, { onClick: function () { return handleTabChange("PAT"); }, text: t("Personal Access Token"), active: activeTab === "PAT", dataCy: "PATTab" })),
            activeTab === "OAuth2" ? (react_1.default.createElement(OAuth2ClientComponent_1.default, { permissions: {
                    read: ["see-api"],
                    write: ["see-api"],
                    manage: ["edit-api"]
                } })) : (react_1.default.createElement(Api_1.default, { tokens: tokens, availablePermissions: availablePermissions, defaultPermissions: defaultPermissions })))));
}
exports.default = ApiTokenIndex;
